var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56708 4.12738L8.54984 5.11014C10.4495 7.00982 10.4495 10.0899 8.54984 11.9895L8.30412 12.2352C6.40448 14.1349 3.32445 14.1349 1.42477 12.2352C-0.474922 10.3355 -0.474922 7.25555 1.42477 5.35583L2.40753 6.3386C1.05061 7.6955 1.05061 9.89556 2.40753 11.2525C3.76445 12.6094 5.96445 12.6094 7.32136 11.2525L7.56708 11.0067C8.92399 9.64983 8.92399 7.44985 7.56708 6.09294L6.58432 5.11014L7.56708 4.12738ZM12.2352 8.30412L11.2525 7.32136C12.6094 5.96445 12.6094 3.76445 11.2525 2.40753C9.89556 1.05061 7.6955 1.05061 6.3386 2.40753L6.09294 2.65323C4.73599 4.01015 4.73599 6.21018 6.09294 7.56708L7.0757 8.54984L6.09294 9.5326L5.11014 8.54984C3.21046 6.65013 3.21046 3.57014 5.11014 1.67045L5.35583 1.42477C7.25555 -0.474922 10.3355 -0.474922 12.2352 1.42477C14.1349 3.32445 14.1349 6.40448 12.2352 8.30412Z",
    fill: "#7E8392"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.267a424ab40ba2a4386bd1e774c27617.svg";
export { ForwardRef as ReactComponent };